<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import ProdutoGroupRequest from 'Modules/contacard/produto/groups/ProdutoGroupRequest';

export default {
  name: 'ProdutoGroupList',
  extends: CrudListVue,
  data: (vm) => ({
    editRoute: 'group.edit',
    requestClass: ProdutoGroupRequest,
    actionOptions: [
      {
        icon: 'mdi-apps',
        name: 'Listar seções',
        handler: (row) => {
          vm.goTo('section-group.list', { groupId: row.id });
        },
      },
    ],
    headers: [
      {
        text: 'Nome',
        value: 'nomProdutoAgrupamento',
      },
      {
        text: 'Código',
        value: 'id',
      },
      {
        text: 'Descrição',
        value: 'descricao',
      },
      {
        text: 'Ordem de exibição',
        value: 'ordemExibicao',
      },
      {
        text: 'Data de criação',
        value: 'createdDate',
        component: 'DataTableDateColumn',
      },
    ],
  }),
  methods: {
    prepareRequest(params) {
      return this.requestClass.list(
        this.defaultParams(params),
      );
    },
    defaultParams(params = {}) {
      return {
        OrderByAsc: 'ordemExibicao',
        ...params,
      };
    },
  },
};
</script>
